<template>
  <div>
    <v-row class="grey darken-4 mx-0 rounded">
      <v-col cols="6" md="4" sm="3" class="align-self-center">
        <v-text-field
          label="Marca"
          persistent-hint
          class="text-caption"
          placeholder="Termo da busca"
          dense
          dark
          outlined
          v-model="searchFields.text"
          :maxlength="searchFields.maxLength"
        />
      </v-col>
    </v-row>
    <index-buttons @search="sendSearch()" @register="openRegister()" @changeHeader="changeHeaderDialog = !changeHeaderDialog" />
    <v-row>
      <v-col cols="12">
        <megabit-table
          :table-header="tableHeaderSelected"
          :table-items="brandList"
          :loading="loadingItems"
          selectable
          :doDelete="doDelete"
          @item-selected="selectItem($event)"
          route="marca.register"
          chave="NOME"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <v-pagination
          class="ml-auto"
          v-model="query.page"
          :total-visible="pagination.per_page"
          :length="pagination.last_page"
          :disabled="loadingItems"
          @input="sendSearch()"
        />
      </v-col>
    </v-row>
    <router-view />
    <change-header 
      v-model="tableHeaderAvaiable"
      :showDialog="changeHeaderDialog" 
      @close="changeHeaderDialog = !changeHeaderDialog" 
      :name="headerName" />
  </div>
</template>

<script>
import { brandMixin } from '@/mixins/object/brand/BrandMixin'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { headerMixin } from "@/mixins/component/table/HeaderMixin"
import MegabitTable from '@/components/shared/table/MegabitTable'
import { mapState, mapActions } from 'vuex'
import IndexButtons from '@/components/shared/base-buttons/IndexButtons';
export default {
  components: { MegabitTable, IndexButtons },
  mixins: [brandMixin, tableMixin, headerMixin],
  data: () => {
    return {
      headerName: 'brandIndex',
      query: { page: 1, nome: '' },
      searchFields: {
        text: '',
        maxLength: 12
      },
      tableHeaderAvaiable:[
        { text: 'Nome', value: 'NOME', align: 'left', show: true },
        { text: 'Ações', value: 'controls', align: 'right', show: true },
      ]
    }
  },
  computed: {
    ...mapState('brandModule', ['brandList', 'loadingItems', 'pagination']),
  },
  mounted() {
    this.fetch()
    this.mountHeader();
  },
  methods: {
    ...mapActions({
      getBrand: 'brandModule/getBrand',
    }),
    async sendSearch() {
      try {
        this.query.nome = this.searchFields.text
        await this.getBrandsAPI(this.query)
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      }
    },

    doDelete(item) {
      // quando for elimiminar precisa alterar para async await e tratar via try catch
      this.$toasted.error(`Não é possível excluir ${item.NOME}`);
    },

    openRegister() {
      //Falta implementar a rota para inserção de marcas
      this.$toasted.info('Indisponível o cadastro de [MARCAS] no momento.')
      // this.$router.push({ name: 'marca.register' })
    },

    async findBrand() {
      try {
        if (this.selectedItem) {
          await this.getBrand(this.selectedItem)
        }
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      }
    },

    async fetch() {
      try {
        await this.getBrandsAPI(this.query)
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      }
    },
  },
}
</script>

<style></style>
